// src/constants/AuthErrorMessages.ts

 enum AuthErrorKeys {
  emailAlreadyExists = "An account with this email already exists.",
  incorrectPassword = "The password you entered is incorrect.",
  notFound = "We couldn’t find an account with this email address.",
  needLoginViaProvider = "Please log in using your linked social account.",
  emailNotExists = "This email address is not registered.",
  invalidHash = "The verification link is invalid or has expired.",
  imageNotExists = "The requested image could not be found.",
  roleNotExists = "The specified role does not exist.",
  statusNotExists = "The user status is not recognized.",
  incorrectOldPassword="Your old password is incorrect"
}

export {AuthErrorKeys};